/**
 * Logger utility that only logs in development
 * In production, logs are suppressed to improve performance and security
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
    log: (...args) => {
        if (isDevelopment) {
            console.log(...args);
        }
    },
    
    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },
    
    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },
    
    error: (...args) => {
        // Always log errors, even in production
        console.error(...args);
        
        // In production, you could send errors to a monitoring service
        // Example: if (!isDevelopment) { sendToSentry(args); }
    },
    
    debug: (...args) => {
        if (isDevelopment) {
            console.debug(...args);
        }
    },
    
    table: (...args) => {
        if (isDevelopment) {
            console.table(...args);
        }
    }
};

export default logger;
